import axios, { AxiosRequestHeaders } from "axios";
import config from "../config";
// import Config from "../Config";
const ApiClient = axios.create({
  baseURL: `${config.apiUrl}`,
  // baseURL: 'https://core.ocplanet.cloud/backend/api/',
  withCredentials: true,

});


// ApiClient.interceptors.response.use(response => {
//   // console.log('res200', response);
//   return response;
// }, error => {
//   // console.log('reserror', error);
//   if(error?.response?.status === 401 || error?.response?.status === 498){
//     // if(localStorage.getItem('clientTokenRefresh')){
//     // } else {
//     //   keycloak.logout()
//     // }
//     return Promise.reject('Update token now');
//   } else {

//     return Promise.reject(error);
//   }

// });

ApiClient.interceptors.request.use(
  config => {
    const headers: AxiosRequestHeaders = (config.headers ?? {}) as AxiosRequestHeaders;

    if (!headers.Authorization) {
      const token = localStorage.getItem('authToken');
      if (token) {
        headers.Authorization = token;
      }
    }

    const language = localStorage.getItem('lang') || 'en';
    headers['Accept-Language'] = language;

    config.headers = headers;

    return config;
  },
  error => Promise.reject(error)
);

// Interceptor для обработки ответов
ApiClient.interceptors.response.use(
  response => response,
  error => {
    // Если получили 401 или 498 (токен истек), разлогиниваем пользователя
    if (error?.response?.status === 401 || error?.response?.status === 498) {
      localStorage.removeItem('onlyu-admin-auth-user');
      localStorage.removeItem('authToken');
      localStorage.removeItem('userRole');
      resetClientToken();

      // Редиректим на страницу логина, если не на ней
      if (window.location.pathname !== '/sign-in') {
        window.location.href = '/sign-in';
      }
    }

    return Promise.reject(error);
  }
);
export const setClientToken = (token: string) => {
  if (token) {
    ApiClient.defaults.headers.common.Authorization = token;
    ApiClient.defaults.withCredentials = true;
  }
};


export const resetClientToken = () => {
  delete ApiClient.defaults.headers.common.Authorization;
};


export default ApiClient
